<template>
	<div>
		<div class="row content-header">
			<div class="content-header-left mb-2 col-md-9 col-12">
				<div class="row breadcrumbs-top">
					<div class="col-12">
						<h2 class="content-header-title float-left pr-1 mb-0">
							<feather-icon icon="ArrowLeftIcon" size="24" class="mr-2" @click="goBack" />Weight
						</h2>
						<div class="breadcrumb-wrapper">
							<ol class="breadcrumb">
								<li class="breadcrumb-item active">
									<span aria-current="location"> Add </span>
								</li>
							</ol>
						</div>
					</div>
				</div>
			</div>
		</div>
		<validation-observer ref="simpleRules">
			<b-form action="apps-data-entry-list" method="post" @submit="addWeightList">
				<b-card>
					<!-- <div class="d-flex justify-content-end mb-0 mt-2 mr-2">
						<b-button variant="primary"> Total Alive Birds : {{ this.total_chick ? total_chick : 0 }} </b-button>
					</div> -->
					<b-row>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Data Entry Date<span class="text-danger">*</span> </template>
								<validation-provider #default="{ errors }" name="Entry Date" :rules="{ required: true }">
									<b-form-datepicker
										v-model="FormData.entry_date"
										menu-class="w-100"
										calendar-width="100%"
										class="mb-1"
									/>
									<small class="text-danger">{{ errors[0] }}</small>
								</validation-provider>
							</b-form-group>
						</b-col>
						<!--    -->
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Weight(KG)<span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider
										#default="{ errors }"
										name="Weight"
										:rules="{
											required: true,
											regex: RegExp(/^\d+(\.\d{1,4})?$/),
										}"
									>
										<b-form-input v-model="FormData.weight" placeholder="Weight" type="text" name="weight" />
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Avg Weight<span class="text-danger">*</span> </template>
								<div class="form-label-group">
									<validation-provider
										#default="{ errors }"
										name="avg weight"
										:rules="{
											required: true,
											regex: RegExp(/^\d+(\.\d{1,4})?$/),
										}"
									>
										<b-form-input
											v-model="FormData.avg_weight"
											placeholder="avg weight"
											type="text"
											name="avg weight"
										/>
										<small class="text-danger">{{ errors[0] }}</small>
									</validation-provider>
								</div>
							</b-form-group>
						</b-col>
						<b-col md="6">
							<b-form-group>
								<template v-slot:label> Sample bird weights (optional) </template>
								<b-form-input
									v-model="FormData.sample_weights"
									placeholder="e.g. 1.8, 2.0, 1.9, 2.1"
									@input="computeFromSamples"
								/>
								<small v-if="sampleStats" class="d-block mt-25" :style="{ color: sampleStats.color }">
									{{ sampleStats.n }} birds · avg {{ sampleStats.mean }} kg · uniformity CV {{ sampleStats.cv }}% ({{ sampleStats.grade }})
								</small>
								<small v-else class="text-muted">Weigh a sample of birds to auto-fill avg weight and track flock uniformity.</small>
							</b-form-group>
						</b-col>
						<!-- submit and reset -->
						<b-col md="12">
							<b-button type="submit" variant="primary" value="Submit" class="mr-1 mb-3"> Submit </b-button>
						</b-col>
					</b-row>
				</b-card>
			</b-form>
		</validation-observer>
	</div>
</template>

<script>
import Logo from "@core/layouts/components/Logo.vue";

import * as Vue from "vue";
import axios from "axios";

import { BASE_URL } from "@core/common/constants";
import moment from "moment";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import {
	BRow,
	BCol,
	BCard,
	BCardBody,
	BButton,
	BCardText,
	BForm,
	BFormGroup,
	BFormInput,
	BInputGroup,
	BInputGroupPrepend,
	BFormTextarea,
	BFormCheckbox,
	BPopover,
	VBToggle,
	BFormSelect,
	BFormDatepicker,
	BInputGroupAppend,
} from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import axiosIns from "@/libs/axios";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
export default {
	components: {
		BRow,
		BCol,
		BCard,
		BCardBody,
		BButton,
		BCardText,
		BForm,
		BFormGroup,
		BFormInput,
		BInputGroup,
		BInputGroupPrepend,
		BFormTextarea,
		BFormCheckbox,
		BPopover,
		BFormSelect,
		BFormDatepicker,
		flatPickr,
		vSelect,
		Logo,
		ValidationProvider,
		ValidationObserver,
	},

	data() {
		return {
			required,
			selected: null,
			FormData: {
				total_stock: null,
				purchase_date: null,
				expiry_date: null,
				price_per_vaccine: null,
				sample_weights: "",
			},
			sampleStats: null,
			selectedVaccine: null,
			selectedSource: null,
			selectedUnit: null,
			selectedRoute: null,
			unitList: [],
			routeList: [],
			breedList: [],
			vaccineList: [],
			sourceList: [],
			formatted_date: null,
		};
	},
	created: function () {
		this.date_function();
		this.flockId = this.$route.params.flockId;
		this.farmId = this.$route.params.farmId;
		this.shedId = this.$route.params.shedId;
	},
	methods: {
		goBack() {
			this.$router.push(`/apps/manage-farm/${this.farmId}/shed/${this.shedId}/data-entry/${this.flockId}`);
		},
		date_function: function () {
			var currentDate = new Date();
			this.formatted_date = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
		},
		computeFromSamples() {
			const nums = String(this.FormData.sample_weights || "")
				.split(/[\s,]+/)
				.map((x) => parseFloat(x))
				.filter((x) => !isNaN(x) && x > 0);
			if (nums.length < 2) {
				this.sampleStats = null;
				return;
			}
			const mean = nums.reduce((s, x) => s + x, 0) / nums.length;
			const sd = Math.sqrt(nums.reduce((s, x) => s + Math.pow(x - mean, 2), 0) / nums.length);
			const cv = mean > 0 ? (sd / mean) * 100 : 0;
			// Broiler uniformity bands: <8 excellent, 8–10 good, 10–12 fair, >12 poor
			let grade = "poor", color = "#EA5455";
			if (cv < 8) { grade = "excellent"; color = "#28C76F"; }
			else if (cv < 10) { grade = "good"; color = "#28C76F"; }
			else if (cv < 12) { grade = "fair"; color = "#FF9F43"; }
			this.sampleStats = { n: nums.length, mean: mean.toFixed(2), cv: cv.toFixed(1), grade, color };
			// Auto-fill avg weight from the sample mean
			this.FormData.avg_weight = mean.toFixed(3);
		},
		addWeightList(e) {
			e.preventDefault();
			this.$refs.simpleRules.validate().then((success) => {
				debugger;
				if (success) {
					var data = new FormData();
					data.append("entry_date", this.FormData.entry_date);
					data.append("weight", this.FormData.weight);
					data.append("avg_weight", this.FormData.avg_weight);
					if (this.FormData.sample_weights) {
						data.append("sample_weights", this.FormData.sample_weights);
					}
					axiosIns
						.post(`web/farm/${this.farmId}/shed/${this.shedId}/flock/${this.flockId}/weight-gain-entry`, data)
						.then((res) => {
							this.$toast({
								component: ToastificationContent,
								position: "top-right",
								props: {
									icon: "CoffeeIcon",
									variant: "success",
									text: `Data Successfully Added `,
								},
							});
							this.$router.push({
								path: `/apps/manage-farm/${this.farmId}/shed/${this.shedId}/data-entry/${this.flockId}`,
							});
						})
						.catch((error) => {
							const data = error.response?.data?.errors;
							data, "data";
							let arr = Object.values(data).flat().toString(",");

							this.$toast({
								component: ToastificationContent,
								position: "top-right",
								props: {
									icon: "CoffeeIcon",
									variant: "danger",
									text: arr,
								},
							});
						});
				}
			});
		},
	},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
.invoice-add-wrapper {
	.add-new-client-header {
		padding: $options-padding-y $options-padding-x;
		color: $success;

		&:hover {
			background-color: rgba($success, 0.12);
		}
	}
}
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";
@import "~@core/scss/base/components/variables-dark";
